import { connect } from 'react-redux'

import { IRootState } from '../../../../common/reducers'

import Grid from './grid'

interface IStateProps {
  selectedItemId: number
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { layout: { selectedItemId } } = state

  return {
    selectedItemId
  }
}

const GridContainer = connect<IStateProps>(mapStateToProps)(Grid)

export default GridContainer
